import { Button } from 'antd';
import debounce from 'lodash.debounce';
import React, { useCallback, useState } from 'react'
import { AiOutlineSearch } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

const MobileSearchInput = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState<string>("");

    // Use useCallback with the ref
    const debouncedSearch = useCallback((query: string) => {
        if (query.trim()) {
            navigate(`/search?query=${encodeURIComponent(query)}`);
        }
    }, [navigate]);

    const debouncedSearchWithDelay = debounce(debouncedSearch, 500);

    const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setSearchQuery(query);
        debouncedSearchWithDelay(query);
    };


    return (
        <div className='primary-gradient p-2'>
            <div className=" rounded-md flex items-center justify-between py-2 w-full">
                {/* Search Input */}
                <input
                    className="flex-grow border-none rounded-tl-md rounded-bl-md bg-surface-default font-semibold text-sm placeholder-content-tertiary focus:outline-none px-2 py-3"
                    type="text"
                    placeholder={'rechercher un produit ici ...'}
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                />
                {/* search Button cta */}
                <Button
                    icon={<AiOutlineSearch size={20} className='text-primary-contrast' />}
                    className="bg-primary-default text-light-default font-semibold rounded-md w-32"
                    onClick={() => debouncedSearchWithDelay(searchQuery)}
                    type="primary"
                    size="large"
                >
                    Rechercher
                </Button>
            </div>
        </div>
    )
}

export default MobileSearchInput